import React from "react";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "src/components/Loading";
import {
  getVendors,
  reset as resetVendors,
} from "src/features/vendors/redux/VendorSlice";
import {
  getItems,
  reset as resetItems,
} from "src/features/items/redux/ItemSlice";
import {
  getWarehouses,
  reset as resetWarehouses,
} from "src/features/warehouses/redux/WarehouseSlice";
import { PageTemplate } from "src/layout/components/PageTemplate";
import { AppDispatch, RootState } from "src/store";
import OrderNewForm from "../componets/OrderNewForm";
import {
  getQualities,
  reset as resetQualities,
} from "src/features/items/redux/qualitySlice";

const OrderNew = () => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch<AppDispatch>();
  const { enqueueSnackbar } = useSnackbar();

  const [vendorsData, setVendors] = useState([] as any);
  const [materialsData, setMaterials] = useState([] as any);
  const [warehousesData, setDataWarehouses] = useState([] as any);
  const [qualitiesData, setQualities] = useState([] as any);

  const {
    vendors,
    isError: isVendorsError,
    isSuccess: isVendorsSuccess,
    message: VendorsMessage,
    isLoading: isVendorsLoading,
  } = useSelector((state: RootState) => state.vendor);
  const {
    Warehouses,
    isError: isWarehousesError,
    isSuccess: isWarehousesSuccess,
    message: WarehousesMessage,
    isLoading: isWarehousesLoading,
  } = useSelector((state: RootState) => state.warehouse);
  const {
    items,
    isError: isItemsError,
    isSuccess: isItemsSuccess,
    message: itemsMessage,
    isLoading: isItemsLoading,
  } = useSelector((state: RootState) => state.items);
  const {
    qualities,
    isError: isQualitiesError,
    isSuccess: isQualitiesSuccess,
    message: QualitiesMessage,
    isLoading: isQualitiesLoading,
  } = useSelector((state: RootState) => state.qualities);

  useEffect(() => {
    if (isVendorsError) {
      enqueueSnackbar(VendorsMessage, { variant: "error" });
    }
    if (isVendorsSuccess) {
      setVendors(vendors);
    }
    return () => {
      dispatch(resetVendors());
    };
  }, [isVendorsError, isVendorsSuccess, VendorsMessage, isVendorsLoading]);

  useEffect(() => {
    if (isWarehousesError) {
      enqueueSnackbar(WarehousesMessage, { variant: "error" });
    }
    if (isWarehousesSuccess) {
      setDataWarehouses(Warehouses);
    }
    return () => {
      dispatch(resetWarehouses());
    };
  }, [
    isWarehousesError,
    isWarehousesSuccess,
    WarehousesMessage,
    isWarehousesLoading,
  ]);

  useEffect(() => {
    if (isItemsError) {
      enqueueSnackbar(itemsMessage, { variant: "error" });
    }
    if (isItemsSuccess) {
      setMaterials(items);
    }
    return () => {
      dispatch(resetItems());
    };
  }, [isItemsError, isItemsSuccess, itemsMessage, isItemsLoading]);

  useEffect(() => {
    if (isQualitiesError) {
      enqueueSnackbar(QualitiesMessage, { variant: "error" });
    }
    if (isQualitiesSuccess) {
      setQualities(qualities);
    }
    return () => {
      dispatch(resetQualities());
    };
  }, [
    isQualitiesError,
    isQualitiesSuccess,
    QualitiesMessage,
    isQualitiesLoading,
  ]);

  useEffect(() => {
    dispatch(
      getVendors({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getWarehouses({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getItems({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getQualities({
        page: page,
        limit: 100,
      })
    );
  }, []);

  return (
    <PageTemplate
      isTransparent
      crumbs={[
        {
          label: "orders",
          href: "/orders/orders-list",
          depth: -1,
        },
        {
          label: "new order",
        },
      ]}
    >
      {isWarehousesLoading || isItemsLoading ? (
        <Loading />
      ) : (
        <OrderNewForm
          vendors={vendors}
          materials={items}
          warehouses={Warehouses}
          qualities={qualities}
        />
      )}
    </PageTemplate>
  );
};

export default OrderNew;
